import React, { useState }  from "react"
import Link from "../../../../../UI/Link/Link"
import PropTypes from "prop-types"
import {labels as recipesListLabels} from '../../../../../../constants/recipeListing.constants'
import { deslashify } from "../../../../../../helpers/utils"

const NavigationItem = props => {
  const { item, toggleMobileNav, isActive } = props
  const { label, link } = item

  const onLinkClick = (e) => {
    if(deslashify(link?.url) === recipesListLabels?.slug){
      e.preventDefault()
    }
  }

  return (
    <li onClick={toggleMobileNav} className={`${isActive} nav-item uppercase text-gray text-left font-MDLZBiteType text-[18px] leading-[1.1]`}>
      {link ? (
        <Link {...link}
          gaEventClass={`inline-block ${isActive} hover:underline event_menu_click}`}
          gaEventLabel={label}
          onClick={onLinkClick}
        >
          {label}
        </Link>
      ) : (
        label
      )}
    </li>
  )
}

NavigationItem.propTypes = {
  toggleMobileNav: PropTypes.func,
  item: PropTypes.shape({
    link: PropTypes.object,
    label: PropTypes.string,
  }),
  isActive: PropTypes.string
}

export default NavigationItem
